export default __webpack_public_path__ + "static/media/arcadis.08c735bb.svg";